import styled from "styled-components";

export const StyledPriceLink = styled.a`
  color: #3989ca;
  justify-content: flex-end;
  cursor: pointer;
  width: fit-content;
  font-weight: ${({ isTargetRow }) => (isTargetRow ? "bold" : "regular")};
`;
